<template lang="html">
  <div class="wrapper fadeInDown">
    <div id="formContent">
      <div class="fadeIn first">
        <img src="@/assets/gw-logo-tall.png" class="login-logo">
      </div>

      <b-form @submit="makeLogin($event)">
        <b-form-group
          id="email-group"
          :label="$t('user.username')"
          label-for="email"
          class="left">
          <b-form-input
            v-model="form.email"
            id="email"
            type="text"
            required
            placeholder="Enter username"
            :class="{'is-invalid': validation}"/>
        </b-form-group>

        <b-form-group
        id="password-group"
        :label="$t('user.password')"
        label-for="password"
        class="left"
        >
          <b-input-group>
            <div class="w-100">
              <GwPassword v-model="form.password"
                          :g-class="validation ? 'login-input error' : 'login-input' "
                          g-placeholder="Enter password"
                          :g-required="true " :showError="false"/>
            </div>
          </b-input-group>
        </b-form-group>
              
        <b-button id="btn-login" block type="submit" variant="primary" :disabled="loading" class="w-50 center-m">
          <span
            class="spinner-border spinner-border-sm"
            v-show="loading"
          />
          {{$t('login.login')}}
        </b-button>
      </b-form>

      <router-link style="margin-top: 10px;" to="/forgot-password">
        {{$t('login.forgotPassword')}}
      </router-link>
    </div>

    <p class="text-center my-3 link-white">
        <a :href="mobileVersionLink" v-text="$t('login.goToMobileVersion')" class="link-white"></a>
    </p>
  </div>
</template>

<script>
import GwPassword from "@/components/gwPassword/GwPassword.vue";
import jwtDecode from "jwt-decode";
import { login, getCourses } from "@/api/index";

export default {
  name: "Login",
  components: {
    GwPassword,
  },
  data() {
    return {
      mobileVersionLink: process.env.VUE_APP_LINK_MOBILE_VERSION,
      form: {
        email: "",
        password: "",
      },

      loading: false,
      validation: false,
    };
  },
  methods: {
    async makeLogin(e) {
      this.loading = true;
      e.preventDefault();

      login(this.form)
        .then(async (data) => {
          if (data.jwt) {
            const decoded = jwtDecode(data.jwt);
            const user = decoded.identity;
            localStorage.setItem("jwt", data.jwt);
            localStorage.setItem("exp", decoded.exp);
            this.$store.commit("setUser", user);
            this.$store.commit("setUserCourses", data.courses);
            
            let full_menu = [...data.menu];
            this.$store.commit("setFullMenu", full_menu);

            let defaultCourse = null;

            this.$store.commit("setUserCourses", data.courses);
            data.courses.find((course) => {
              if (user.default_course_id == course.course_id) {
                defaultCourse = course;
              }
            });
            defaultCourse = defaultCourse ? defaultCourse : data.courses[0];
            this.$store.commit("setCourse", defaultCourse);

            this.$i18n.locale = user.language
              ? user.language
              : this.$i18n.locale;

            this.$store.commit(
              "setMenuPolicy",
              data.menu.sort(function (a, b) {
                return a.orden == b.orden ? 0 : a.orden > b.orden ? 1 : -1;
              })
            );

            let idx = data.menu.findIndex(item => item.name == 'Holes')

            if(idx > 0 && defaultCourse.facility_type && !defaultCourse.facility_type.is_golf_course ){
              data.menu[idx].i18n = 'zones.zones'
            }else{
              data.menu[idx].i18n = 'holes.holes';
            }

            idx = data.menu.findIndex(item => (item.name == 'Course View' || item.name == 'Course'))

            if(idx > 0 && defaultCourse.facility_type && !defaultCourse.facility_type.is_golf_course ){
              data.menu.splice(idx, 1);
            }

            idx = data.menu.findIndex(item => item.name == 'Facility View')

            if(idx > 0 && defaultCourse.facility_type && defaultCourse.facility_type.is_golf_course ){
              data.menu.splice(idx, 1);
            }

            this.$store.commit("setLogged", true);
            if (process.env.VUE_APP_SENTRY_ENV == "production") {
              this.$analytics.logEvent("web_login");
            }
            this.$router.push("/dashboard");
          }
          this.loading = false;
        })
        .catch((e) => {
          this.validation = true;
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./login.scss";
</style>
